module.exports = __webpack_public_path__ + "static/media/flamp160.508bcda2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/flamp160.svg
// module id = 2016
// module chunks = 0